import React, { useEffect, useState } from 'react';
import backgroundImg from 'assets/img/basic-background.jpg';
import { AuthWrapper } from 'components/AuthContainer/AuthWrapper';
import Modal from 'components/Modal';
import RestorePasswordForm from 'components/AuthContainer/RestorePasswordForm';

import { BodyContainer } from 'components/App/style.js';
import { BackgroundImg } from 'components/Header/style.js';

const RestorePassword = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const time = setTimeout(() => {
      setShow(true);
    }, 1000);

    return () => {
      clearTimeout(time);
    };
  }, []);

  return (
    <BodyContainer>
      <BackgroundImg $imgUrl={`${backgroundImg}`} />
      <Modal show={show} showCloseBtn={false}>
        <AuthWrapper title="Please enter your email">
          <RestorePasswordForm />
        </AuthWrapper>
      </Modal>
    </BodyContainer>
  );
};

export default RestorePassword;
